import type { ButtonTypeMap } from "@mui/base/Button";
import classnames from "classnames";
import type { HTMLProps } from "react";
import { forwardRef } from "react";

import { ButtonStyled } from "./styles";

export type Props = ButtonTypeMap["props"] & {
  className?: string;
  icon?: boolean;
  noStyle?: boolean;
  text?: boolean;
} & Omit<HTMLProps<HTMLButtonElement>, "as" | "ref">;

export const Button = forwardRef<HTMLButtonElement, Props>(
  ({ children, className, icon, noStyle, text, ...props }, reference) => (
    <ButtonStyled
      ref={reference}
      {...props}
      className={classnames(
        {
          default: !text && !noStyle,
          icon,
          text,
        },
        className,
      )}
    >
      {children}
    </ButtonStyled>
  ),
);

Button.displayName = "Button";
